import { useEffect, useState } from 'react'

import { getLinkPreview } from '@/services/support'
import type { LinkPreviewDto } from '../types'

// Null while the service is still answering, and null for good when it has
// nothing to show or the call fails. A preview is a nicety: a link the service
// cannot read leaves the message exactly as it was, with nothing to report.
export const useLinkPreview = (url: string): LinkPreviewDto | null => {
  const [preview, setPreview] = useState<LinkPreviewDto | null>(null)

  useEffect(() => {
    let stillMounted = true

    getLinkPreview(url)
      .then((fetched) => {
        if (stillMounted) setPreview(fetched)
      })
      .catch(() => {})

    return () => {
      stillMounted = false
    }
  }, [url])

  return preview
}
